import dayjs from "dayjs";
import { parseCsvDateToIsoOptional } from "./csvDate";
import { getDueDatePart } from "./dueDateTime";

/** URL query param when ARK ETF list is filtered to recent buys. */
export const STOCK_ARK_RECENT_BUY_PARAM = "arkRecentBuy";
export const STOCK_ARK_RECENT_BUY_VALUE = "1";

/** Default window: trade date within the last 30 calendar days (inclusive). */
export const STOCK_ARK_RECENT_BUY_DAYS = 30;

/**
 * Calendar YYYY-MM-DD for ARK trade_date (UTC date-only safe).
 * @param {unknown} tradeDate
 * @returns {string}
 */
export function getStockTradeDateCalendarYmd(tradeDate) {
  const fromDue = getDueDatePart(tradeDate);
  if (fromDue) return fromDue;
  const raw = tradeDate != null ? String(tradeDate).trim() : "";
  if (!raw) return "";
  const parsed = parseCsvDateToIsoOptional(raw);
  return parsed.ok && parsed.iso ? parsed.iso : "";
}

/**
 * @param {unknown} tradeDate
 * @param {{ days?: number, today?: import('dayjs').Dayjs }} [options]
 * @returns {boolean}
 */
export function isStockTradeDateWithinRecentDays(tradeDate, options = {}) {
  const days =
    Number.isFinite(options.days) && options.days >= 0 ? options.days : STOCK_ARK_RECENT_BUY_DAYS;
  const ymd = getStockTradeDateCalendarYmd(tradeDate);
  if (!ymd) return false;
  const target = dayjs(ymd, "YYYY-MM-DD", true);
  if (!target.isValid()) return false;
  const today = (options.today ?? dayjs()).startOf("day");
  const start = today.subtract(days, "day");
  const t = target.startOf("day");
  return !t.isBefore(start) && !t.isAfter(today);
}

/**
 * @param {Array<{ trade_date?: unknown }>} rows
 * @param {{ days?: number, today?: import('dayjs').Dayjs }} [options]
 * @returns {Array}
 */
export function filterStocksWithRecentBuy(rows, options = {}) {
  return (rows || []).filter((row) => isStockTradeDateWithinRecentDays(row?.trade_date, options));
}

/**
 * @param {Array<{ trade_date?: unknown }>} rows
 * @param {{ days?: number, today?: import('dayjs').Dayjs }} [options]
 * @returns {number}
 */
export function countStocksWithRecentBuy(rows, options = {}) {
  return filterStocksWithRecentBuy(rows, options).length;
}

/**
 * @param {string|null|undefined} paramValue
 * @returns {boolean}
 */
export function isStockArkRecentBuyUrlActive(paramValue) {
  return paramValue === STOCK_ARK_RECENT_BUY_VALUE;
}
